import AlterarTitulo from './AlterarTitulo';
import Default from './Default';
import Editar from './Editar';
import Observacoes from './Observacoes';

const TarefasDefault = Default;

export default TarefasDefault;
export const TarefasEditar = Editar;
export const TarefasObservacoes = Observacoes;
export const TarefasAlterarTitulo = AlterarTitulo;
